(function () {
    'use strict';

    angular.module("imApp").factory("stockVariantsService", ['$ihttp', function ($ihttp) {
        let service = {
            getMenu: function (parms) {
                return $ihttp.post({
                    method: 463,
                    parameters: parms || {}
                });
            },
            listStockVariantsOfProdIds: function (parms) {
                return $ihttp.post({
                    method: 464,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
